import styles from "~/components/Faq/FaqSearchResult.module.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes } from "@fortawesome/pro-regular-svg-icons";

const FaqSearchResult = ({
  content,
  isInitialized,
  openedFaqs,
  setOpenedFaqs,
}) => {
  const { question, answers } = content;
  const isOpen = openedFaqs.includes(question);

  const closeFaq = (selectedQuestion) => {
    const filteredFaqs = openedFaqs.filter(
      (openedFaq) => openedFaq !== selectedQuestion
    );
    setOpenedFaqs(filteredFaqs);
  };

  const handleClick = (selectedQuestion) => {
    if (isOpen) {
      closeFaq(selectedQuestion);
    } else {
      setOpenedFaqs([...openedFaqs, selectedQuestion]);
    }
  };

  return (
    <div
      onClick={() => handleClick(question)}
      className={styles["FaqSearchResult"]}
    >
      <div className={styles["FaqSearchResult__qa-wrapper"]}>
        <h4
          className={`${styles["FaqSearchResult__sub-sub-heading"]}  ${styles["--left"]}
    `}
        >
          {question}
        </h4>
        {(isOpen || !isInitialized) &&
          answers.map((answer, index) => (
            <div className={styles["FaqSearchResult__answer"]} key={index}>
              {answer}
            </div>
          ))}
      </div>
      <div
        className={
          styles["FaqSearchResult__default-answer-wrapper__icon-wrapper"]
        }
      >
        {isOpen ? (
          <FontAwesomeIcon
            className={
              styles[
                "FaqSearchResult__default-answer-wrapper__icon-wrapper__icon"
              ]
            }
            icon={faTimes}
            onClick={() => closeFaq(question)}
          />
        ) : (
          <FontAwesomeIcon
            className={
              styles[
                "FaqSearchResult__default-answer-wrapper__icon-wrapper__icon"
              ]
            }
            icon={faPlus}
            onClick={() => setOpenedFaqs([...openedFaqs, question])}
          />
        )}
      </div>
    </div>
  );
};

export default FaqSearchResult;
